import { render, staticRenderFns } from "./work.vue?vue&type=template&id=4a71b80e&scoped=true&"
import script from "./work.vue?vue&type=script&lang=js&"
export * from "./work.vue?vue&type=script&lang=js&"
import style0 from "./work.vue?vue&type=style&index=0&id=4a71b80e&lang=scss&scoped=true&"
import style1 from "./work.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71b80e",
  null
  
)

export default component.exports